import { createFileRoute } from '@tanstack/react-router';
import { BillboardPage } from '@/page/BillboardPage';

export const Route = createFileRoute('/_app/billboard')({ component: BillboardPage });
